export function getErrorMessage(errorCode) {
    let message = "";
    switch (errorCode) {
        case 501:
            message = "Username not found";
            break;
        case 508:
            message = "Username or password are wrong";
            break;
        case 506:
            message = "Email already in use, please login to easytrip account.";
            break;
        case 503:
            message = "Password too weak.";
            break;
        default:
            message = "Fail to create user";
            break;
    }
    return message;
}


// WEBPACK FOOTER //
// ./src/utils/error-parser.js